import { brand } from '../../design-system/theme/tokens';

export const ONBOARDING_COLORS = {
  primary: brand.primary,
  primaryPressed: '#1B3A9C',
  primaryDisabled: '#93A8E8',
  primarySubtle: '#EEF2FF',
  onPrimary: '#FFFFFF',
  secondary: '#F59E0B',
  success: '#10B981',
  successSubtle: '#ECFDF5',
  error: '#EF4444',
  errorSubtle: '#FEF2F2',
  background: '#FFFFFF',
  surface: '#F9FAFB',
  surfaceDisabled: '#F3F4F6',
  backdrop: 'rgba(17, 24, 39, 0.5)',
  border: '#E5E7EB',
  focusRing: '#93C5FD',
  text: {
    primary: '#111827',
    secondary: '#4B5563',
    muted: '#9CA3AF',
    disabled: '#B0B7C3',
  },
} as const;

export const ONBOARDING_SPACING = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
} as const;

export const ONBOARDING_TYPOGRAPHY = {
  title: { fontSize: 24, lineHeight: 32, fontWeight: '700' },
  subtitle: { fontSize: 18, lineHeight: 26, fontWeight: '600' },
  body: { fontSize: 16, lineHeight: 24, fontWeight: '400' },
  bodySmall: { fontSize: 14, lineHeight: 20, fontWeight: '400' },
  caption: { fontSize: 12, lineHeight: 18, fontWeight: '400' },
  button: { fontSize: 16, lineHeight: 22, fontWeight: '600' },
} as const;

export const ONBOARDING_RADII = {
  sm: 8,
  md: 12,
  lg: 16,
  pill: 999,
} as const;

/** Minimum interactive control height/width — WCAG-ish 44pt touch target. */
export const ONBOARDING_CONTROL_HEIGHT = 44;

/** Max readable content width on wide viewports. */
export const ONBOARDING_CONTENT_MAX_WIDTH = 640;

/** Min height for the step card on roomy breakpoints so CTAs don't jump between steps. */
export const ONBOARDING_STEP_CARD_MIN_HEIGHT = 420;

/** Min height reserved for the tour's feature-detail region to avoid layout shift. */
export const ONBOARDING_FEATURE_DETAIL_MIN_HEIGHT = 96;

/** Max height for modal surfaces (e.g. sample report viewer) relative to viewport. */
export const ONBOARDING_MODAL_MAX_HEIGHT = '94%';

export const ONBOARDING_PROGRESS_TRANSITION_MS = 200;
export const ONBOARDING_DISCLOSURE_TRANSITION_MS = 180;
export const ONBOARDING_REVEAL_TRANSITION_MS = 250;

export default ONBOARDING_COLORS;
